const GEO_SETTINGS = {
  timeout: 10000,
}

const RECENT_SEARCHES_COUNT = 5

export { GEO_SETTINGS, RECENT_SEARCHES_COUNT }
